module.exports = __webpack_public_path__ + "img/e4d15ef322f6470aaaf48d66c8cf8480-640.69cdb9b3.jpg";